import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { configuracionService } from '../services/api';
import '../styles/Configuracion.css';

const Configuracion = () => {
  const { codigo } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [activeTab, setActiveTab] = useState('general');
  const [message, setMessage] = useState({ type: '', text: '' });

  // Estados para cada sección
  const [generalData, setGeneralData] = useState({
    nombre_usuario: '',
    dni: '',
    tipo_documento: 'cedula',
    direccion: '',
    celular: '',
    correo: '',
    nombre_empresa: '',
    rnc: '',
    direccion_empresa: '',
    provincia_empresa: '',
    municipio_empresa: '',
    telefono_empresa: '',
    slogan: '',
    logo: null
  });

  const [impresoraConfig, setImpresoraConfig] = useState({
    impresora_activa: false,
    nombre_impresora: '',
    ancho_papel: 58
  });

  const [passwordData, setPasswordData] = useState({
    password_actual: '',
    password_nueva: '',
    password_confirmar: ''
  });

  const [moraConfig, setMoraConfig] = useState({
    mensual: 10,
    quincenal: 10,
    semanal: 10,
    bisemanal: 10,
    interdiario: 10,
    diario: 10,
    dias_gracia_mensual: 3,
    dias_gracia_quincenal: 3,
    dias_gracia_semanal: 3,
    dias_gracia_bisemanal: 3,
    dias_gracia_interdiario: 3,
    dias_gracia_diario: 3
  });

  const [diaInteresConfig, setDiaInteresConfig] = useState({
    mensual: 15,
    quincenal: 5,
    semanal: 2,
    bisemanal: 4
  });

  const [whatsappConfig, setWhatsappConfig] = useState({
    activo: false,
    numero: '',
    api_key: '',
    instancia_id: ''
  });

  const [reciboConfig, setReciboConfig] = useState({
    amortizado: {
      mostrar_cliente: true,
      mostrar_monto_inicial: true,
      mostrar_cuota_nro: true,
      mostrar_pago_total: true,
      mostrar_pago_capital: true,
      mostrar_pago_interes: true,
      mostrar_pago_mora: true,
      mostrar_pago_abono: true,
      mostrar_efectividad: true,
      mostrar_inicio: true,
      mostrar_termino: true
    },
    capital_final: {
      mostrar_cliente: true,
      mostrar_monto_inicial: true,
      mostrar_cuota_nro: true,
      mostrar_pago_total: true,
      mostrar_pago_capital: true,
      mostrar_pago_interes: true,
      mostrar_pago_faltante: true,
      mostrar_faltante: true,
      mostrar_efectividad: true
    },
    pendientes: {
      mostrar_vencidas: true,
      mostrar_atrasos: true,
      mostrar_faltantes: true,
      mostrar_capital: true,
      mostrar_total: true,
      mostrar_mora: true,
      mostrar_cuotas: true
    }
  });

  const [panelConfig, setPanelConfig] = useState({
    frecuencia_tasa: 'mensual',
    mostrar_prestamos_capital_final: true,
    mostrar_prestamos_amortizados: true
  });

  const [modalidadesConfig, setModalidadesConfig] = useState({
    mensual: true,
    quincenal: true,
    bisemanal: false,
    semanal: true,
    interdiario: false,
    diario: true
  });

  const [finanzasConfig, setFinanzasConfig] = useState({
    activo: false,
    bancos: false,
    gastos: false,
    cuadre_caja: false,
    caja_chica: false,
    transacciones: false,
    suplidores: false,
    factura_suplidores: false,
    pago_suplidores: false,
    cuentas_pagar: false
  });

  const [prestamosConfig, setPrestamosConfig] = useState({
    deben_pagar_con_adelantados: true,
    aumentar_mora_vencido: false
  });

  const [abogadoConfig, setAbogadoConfig] = useState({
    nombre: '',
    cedula: '',
    direccion: '',
    matricula: ''
  });

  useEffect(() => {
    // Verificar que el tenant de la URL coincida con el del token
    const verificarTenant = () => {
      const token = localStorage.getItem('token');
      const tenantCodigo = localStorage.getItem('tenant_codigo');
      
      if (!token) {
        // No hay token, redirigir al login
        navigate(codigo ? `/${codigo}/login` : '/login');
        return false;
      }
      
      if (codigo && tenantCodigo && codigo.toLowerCase() !== tenantCodigo.toLowerCase()) {
        // El tenant de la URL no coincide con el del token - forzar logout y re-login
        console.warn(`⚠️ Tenant mismatch: URL=${codigo}, Token=${tenantCodigo}. Forzando logout.`);
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('tenant_codigo');
        localStorage.removeItem('tenant_info');
        alert('⚠️ El tenant de la URL no coincide con tu sesión. Por favor, inicia sesión nuevamente.');
        navigate(`/${codigo}/login`);
        return false;
      }
      
      return true;
    };
    
    if (verificarTenant()) {
      cargarConfiguracion();
    }
  }, [codigo, navigate]);

  const cargarConfiguracion = async () => {
    setLoading(true);
    try {
      const response = await configuracionService.getConfiguracion();
      const config = response.data;
      
      // Verificar que la configuración devuelta corresponde al tenant correcto
      console.log('📋 Configuración cargada:', config);

      if (config.general) setGeneralData(config.general);
      if (config.impresora) setImpresoraConfig(config.impresora);
      if (config.mora) setMoraConfig(config.mora);
      if (config.dia_interes) setDiaInteresConfig(config.dia_interes);
      if (config.whatsapp) setWhatsappConfig(config.whatsapp);
      if (config.recibo) setReciboConfig(config.recibo);
      if (config.panel) setPanelConfig(config.panel);
      if (config.modalidades) setModalidadesConfig(config.modalidades);
      if (config.finanzas) setFinanzasConfig(config.finanzas);
      if (config.prestamos) setPrestamosConfig(config.prestamos);
      if (config.abogado) setAbogadoConfig(config.abogado);

    } catch (error) {
      console.error('Error al cargar configuración:', error);
      showMessage('error', 'Error al cargar la configuración');
    } finally {
      setLoading(false);
    }
  };

  const guardarConfiguracion = async (seccion, data) => {
    setSaving(true);
    try {
      await configuracionService.updateConfiguracion(seccion, data);
      showMessage('success', 'Configuración guardada exitosamente');
      await cargarConfiguracion();
    } catch (error) {
      console.error('Error al guardar configuración:', error);
      showMessage('error', error.response?.data?.error || 'Error al guardar la configuración');
    } finally {
      setSaving(false);
    }
  };

  const cambiarPassword = async () => {
    if (passwordData.password_nueva !== passwordData.password_confirmar) {
      showMessage('error', 'Las contraseñas no coinciden');
      return;
    }

    if (passwordData.password_nueva.length < 6) {
      showMessage('error', 'La contraseña debe tener al menos 6 caracteres');
      return;
    }

    setSaving(true);
    try {
      await configuracionService.cambiarPassword({
        password_actual: passwordData.password_actual,
        password_nueva: passwordData.password_nueva
      });
      showMessage('success', 'Contraseña cambiada exitosamente');
      setPasswordData({
        password_actual: '',
        password_nueva: '',
        password_confirmar: ''
      });
    } catch (error) {
      console.error('Error al cambiar contraseña:', error);
      showMessage('error', error.response?.data?.error || 'Error al cambiar la contraseña');
    } finally {
      setSaving(false);
    }
  };

  const handleLogoUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!file.type.startsWith('image/')) {
      showMessage('error', 'Por favor seleccione una imagen válida');
      return;
    }

    if (file.size > 2 * 1024 * 1024) {
      showMessage('error', 'La imagen no debe superar 2MB');
      return;
    }

    const formData = new FormData();
    formData.append('logo', file);

    setSaving(true);
    try {
      const response = await configuracionService.uploadLogo(formData);
      setGeneralData({ ...generalData, logo: response.data.logo_url });
      showMessage('success', 'Logo actualizado exitosamente');
    } catch (error) {
      console.error('Error al subir logo:', error);
      showMessage('error', 'Error al subir el logo');
    } finally {
      setSaving(false);
    }
  };

  const borrarLogo = async () => {
    if (!window.confirm('¿Está seguro de que desea eliminar el logo?')) return;

    setSaving(true);
    try {
      await configuracionService.deleteLogo();
      setGeneralData({ ...generalData, logo: null });
      showMessage('success', 'Logo eliminado exitosamente');
    } catch (error) {
      console.error('Error al eliminar logo:', error);
      showMessage('error', 'Error al eliminar el logo');
    } finally {
      setSaving(false);
    }
  };

  const showMessage = (type, text) => {
    setMessage({ type, text });
    setTimeout(() => setMessage({ type: '', text: '' }), 5000);
  };

  const tabs = [
    { id: 'general', label: 'General', icon: '⚙️' },
    { id: 'impresora', label: 'Impresora Bluetooth', icon: '🖨️' },
    { id: 'password', label: 'Contraseña', icon: '🔒' },
    { id: 'mora', label: 'Mora', icon: '⏰' },
    { id: 'dia_interes', label: 'Día Interés', icon: '📅' },
    { id: 'whatsapp', label: 'Mi WhatsApp', icon: '💬' },
    { id: 'recibo', label: 'Recibos', icon: '🧾' },
    { id: 'panel', label: 'Panel y Tasa', icon: '📊' },
    { id: 'modalidades', label: 'Modalidades', icon: '💰' },
    { id: 'finanzas', label: 'Finanzas', icon: '💼' },
    { id: 'prestamos', label: 'Préstamos', icon: '📋' },
    { id: 'abogado', label: 'Abogado', icon: '⚖️' }
  ];

  if (loading) {
    return (
      <div className="configuracion-page">
        <div className="loading-container">
          <div className="spinner"></div>
          <p>Cargando configuración...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="configuracion-page">
      <div className="configuracion-header">
        <h1>⚙️ Configuración</h1>
        <p className="subtitle">Configuración general del sistema</p>
      </div>

      {message.text && (
        <div className={`message-alert ${message.type}`}>
          {message.type === 'success' ? '✓' : '⚠'} {message.text}
        </div>
      )}

      <div className="configuracion-container">
        <div className="config-sidebar">
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`config-tab ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <span className="tab-icon">{tab.icon}</span>
              <span className="tab-label">{tab.label}</span>
            </button>
          ))}
        </div>

        <div className="config-content">
          {/* GENERAL */}
          {activeTab === 'general' && (
            <div className="config-section">
              <h2>Configuración General</h2>

              <div className="config-grid-2">
                <div className="config-card">
                  <h3 className="card-title">👤 Mis datos</h3>
                  <div className="form-group">
                    <label>Nombre</label>
                    <input
                      type="text"
                      value={generalData.nombre_usuario}
                      onChange={(e) => setGeneralData({...generalData, nombre_usuario: e.target.value})}
                      placeholder="Tu nombre completo"
                    />
                  </div>

                  <div className="form-group">
                    <label>DNI</label>
                    <input
                      type="text"
                      value={generalData.dni}
                      onChange={(e) => setGeneralData({...generalData, dni: e.target.value})}
                      placeholder="000-0000000-0"
                    />
                    <div className="radio-group">
                      <label>
                        <input
                          type="radio"
                          value="cedula"
                          checked={generalData.tipo_documento === 'cedula'}
                          onChange={(e) => setGeneralData({...generalData, tipo_documento: e.target.value})}
                        />
                        Cédula
                      </label>
                      <label>
                        <input
                          type="radio"
                          value="rnc"
                          checked={generalData.tipo_documento === 'rnc'}
                          onChange={(e) => setGeneralData({...generalData, tipo_documento: e.target.value})}
                        />
                        RNC
                      </label>
                      <label>
                        <input
                          type="radio"
                          value="pasaporte"
                          checked={generalData.tipo_documento === 'pasaporte'}
                          onChange={(e) => setGeneralData({...generalData, tipo_documento: e.target.value})}
                        />
                        Pasaporte
                      </label>
                    </div>
                  </div>

                  <div className="form-group">
                    <label>Dirección</label>
                    <input
                      type="text"
                      value={generalData.direccion}
                      onChange={(e) => setGeneralData({...generalData, direccion: e.target.value})}
                      placeholder="Calle, #Casa, Sector, Municipio, Provincia"
                    />
                  </div>

                  <div className="form-group">
                    <label>Celular</label>
                    <input
                      type="tel"
                      value={generalData.celular}
                      onChange={(e) => setGeneralData({...generalData, celular: e.target.value})}
                      placeholder="(829) 928-8061"
                    />
                  </div>

                  <div className="form-group">
                    <label>Correo</label>
                    <input
                      type="email"
                      value={generalData.correo}
                      onChange={(e) => setGeneralData({...generalData, correo: e.target.value})}
                      placeholder="correo@ejemplo.com"
                    />
                  </div>

                  <button
                    className="btn btn-primary"
                    onClick={() => guardarConfiguracion('general', generalData)}
                    disabled={saving}
                  >
                    {saving ? 'Guardando...' : 'Actualizar'}
                  </button>
                </div>

                <div className="config-card">
                  <h3 className="card-title">🏢 Mi Empresa / Negocio</h3>

                  <div className="form-group">
                    <label>Nombre</label>
                    <input
                      type="text"
                      value={generalData.nombre_empresa}
                      onChange={(e) => setGeneralData({...generalData, nombre_empresa: e.target.value})}
                      placeholder="Nombre de la empresa"
                    />
                  </div>

                  <div className="form-group">
                    <label>RNC</label>
                    <input
                      type="text"
                      value={generalData.rnc}
                      onChange={(e) => setGeneralData({...generalData, rnc: e.target.value})}
                      placeholder="Ingrese valor"
                    />
                  </div>

                  <div className="form-group">
                    <label>Dirección</label>
                    <input
                      type="text"
                      value={generalData.direccion_empresa}
                      onChange={(e) => setGeneralData({...generalData, direccion_empresa: e.target.value})}
                      placeholder="Calle, #Casa, Sector, Municipio, Provincia"
                    />
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label>Teléfono</label>
                      <input
                        type="tel"
                        value={generalData.telefono_empresa}
                        onChange={(e) => setGeneralData({...generalData, telefono_empresa: e.target.value})}
                        placeholder="(829) 928-8061"
                      />
                    </div>

                    <div className="form-group">
                      <label>Slogan</label>
                      <input
                        type="text"
                        value={generalData.slogan}
                        onChange={(e) => setGeneralData({...generalData, slogan: e.target.value})}
                        placeholder="Slogan de la empresa"
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label>Logo</label>
                    {generalData.logo ? (
                      <div className="logo-preview">
                        <div className="logo-display">
                          <p className="no-logo-text">Logo cargado</p>
                        </div>
                        <div className="logo-actions">
                          <button className="btn btn-secondary" onClick={() => document.getElementById('logo-input').click()}>
                            Cambiar Logo
                          </button>
                          <button className="btn btn-warning" onClick={borrarLogo}>
                            Borrar Logo
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div className="no-logo">
                        <p className="no-logo-text">Sin Logo</p>
                        <p className="logo-hint">
                          La imagen debe tener el fondo blanco.<br/>
                          Lo ideal es que sea un logo de color oscuro o negro, por las impresoras blanco y negro.
                        </p>
                        <input
                          id="logo-input"
                          type="file"
                          accept="image/*"
                          onChange={handleLogoUpload}
                          style={{ display: 'none' }}
                        />
                        <button className="btn btn-primary" onClick={() => document.getElementById('logo-input').click()}>
                          Browse...
                        </button>
                      </div>
                    )}
                    <input
                      id="logo-input"
                      type="file"
                      accept="image/*"
                      onChange={handleLogoUpload}
                      style={{ display: 'none' }}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* IMPRESORA BLUETOOTH */}
          {activeTab === 'impresora' && (
            <div className="config-section">
              <h2>🖨️ Impresora Bluetooth</h2>
              <div className="config-card">
                <div className="form-group">
                  <label className="switch-container">
                    <input
                      type="checkbox"
                      checked={impresoraConfig.impresora_activa}
                      onChange={(e) => setImpresoraConfig({...impresoraConfig, impresora_activa: e.target.checked})}
                    />
                    <span className="switch-slider"></span>
                    <span className="switch-label">Activar impresora Bluetooth</span>
                  </label>
                </div>

                {impresoraConfig.impresora_activa && (
                  <>
                    <div className="form-group">
                      <label>Nombre de la impresora</label>
                      <input
                        type="text"
                        value={impresoraConfig.nombre_impresora}
                        onChange={(e) => setImpresoraConfig({...impresoraConfig, nombre_impresora: e.target.value})}
                        placeholder="Ej: BluTooth Printer"
                      />
                    </div>

                    <div className="form-group">
                      <label>Ancho del papel (mm)</label>
                      <select
                        value={impresoraConfig.ancho_papel}
                        onChange={(e) => setImpresoraConfig({...impresoraConfig, ancho_papel: parseInt(e.target.value)})}
                      >
                        <option value="58">58mm</option>
                        <option value="80">80mm</option>
                      </select>
                    </div>

                    <div className="impresora-instrucciones">
                      <h4>Pasos para configurar:</h4>
                      <ol>
                        <li>Conecte su impresora vía bluetooth</li>
                        <li>Dele a ver impresoras</li>
                        <li>Busque el nombre de su impresora</li>
                        <li>Toque nombre de su impresora</li>
                        <li>Imprima un recibo de prueba en el botón azul</li>
                      </ol>
                    </div>

                    <div className="button-group">
                      <button className="btn btn-warning">🖨️ Ver Impresoras</button>
                      <button className="btn btn-primary">🖨️ Imprimir</button>
                    </div>
                  </>
                )}

                <button
                  className="btn btn-primary"
                  onClick={() => guardarConfiguracion('impresora', impresoraConfig)}
                  disabled={saving}
                >
                  {saving ? 'Guardando...' : 'Actualizar'}
                </button>
              </div>
            </div>
          )}

          {/* CONTRASEÑA */}
          {activeTab === 'password' && (
            <div className="config-section">
              <h2>🔒 Cambiar Contraseña</h2>
              <div className="config-card config-card-small">
                <div className="form-group">
                  <label>Contraseña Actual</label>
                  <input
                    type="password"
                    value={passwordData.password_actual}
                    onChange={(e) => setPasswordData({...passwordData, password_actual: e.target.value})}
                    placeholder="Ingrese su contraseña actual"
                  />
                </div>

                <div className="form-group">
                  <label>Nueva Contraseña</label>
                  <input
                    type="password"
                    value={passwordData.password_nueva}
                    onChange={(e) => setPasswordData({...passwordData, password_nueva: e.target.value})}
                    placeholder="Mínimo 6 caracteres"
                  />
                </div>

                <div className="form-group">
                  <label>Confirmar Nueva Contraseña</label>
                  <input
                    type="password"
                    value={passwordData.password_confirmar}
                    onChange={(e) => setPasswordData({...passwordData, password_confirmar: e.target.value})}
                    placeholder="Repita la nueva contraseña"
                  />
                </div>

                <button
                  className="btn btn-primary"
                  onClick={cambiarPassword}
                  disabled={saving || !passwordData.password_actual || !passwordData.password_nueva}
                >
                  {saving ? 'Cambiando...' : 'Cambiar Contraseña'}
                </button>
              </div>
            </div>
          )}

          {/* MORA - Continuará en el siguiente bloque... */}
          {activeTab === 'mora' && (
            <div className="config-section">
              <h2>⏰ Configuración de Mora y Días de Gracia</h2>

              <div className="config-grid-3">
                {/* Mensual */}
                <div className="config-card mora-card blue">
                  <h3>Préstamos Mensuales</h3>
                  <div className="form-group">
                    <label>Porcentaje de Mora (%)</label>
                    <input
                      type="number"
                      value={moraConfig.mensual}
                      onChange={(e) => setMoraConfig({...moraConfig, mensual: parseFloat(e.target.value) || 0})}
                      min="0"
                      max="100"
                      step="0.1"
                    />
                  </div>
                  <div className="form-group">
                    <label>Días de Gracia</label>
                    <input
                      type="number"
                      value={moraConfig.dias_gracia_mensual}
                      onChange={(e) => setMoraConfig({...moraConfig, dias_gracia_mensual: parseInt(e.target.value) || 0})}
                      min="0"
                      max="30"
                    />
                  </div>
                </div>

                {/* Quincenal */}
                <div className="config-card mora-card green">
                  <h3>Préstamos Quincenales</h3>
                  <div className="form-group">
                    <label>Porcentaje de Mora (%)</label>
                    <input
                      type="number"
                      value={moraConfig.quincenal}
                      onChange={(e) => setMoraConfig({...moraConfig, quincenal: parseFloat(e.target.value) || 0})}
                      min="0"
                      max="100"
                      step="0.1"
                    />
                  </div>
                  <div className="form-group">
                    <label>Días de Gracia</label>
                    <input
                      type="number"
                      value={moraConfig.dias_gracia_quincenal}
                      onChange={(e) => setMoraConfig({...moraConfig, dias_gracia_quincenal: parseInt(e.target.value) || 0})}
                      min="0"
                      max="30"
                    />
                  </div>
                </div>

                {/* Semanal */}
                <div className="config-card mora-card cyan">
                  <h3>Préstamos Semanales</h3>
                  <div className="form-group">
                    <label>Porcentaje de Mora (%)</label>
                    <input
                      type="number"
                      value={moraConfig.semanal}
                      onChange={(e) => setMoraConfig({...moraConfig, semanal: parseFloat(e.target.value) || 0})}
                      min="0"
                      max="100"
                      step="0.1"
                    />
                  </div>
                  <div className="form-group">
                    <label>Días de Gracia</label>
                    <input
                      type="number"
                      value={moraConfig.dias_gracia_semanal}
                      onChange={(e) => setMoraConfig({...moraConfig, dias_gracia_semanal: parseInt(e.target.value) || 0})}
                      min="0"
                      max="30"
                    />
                  </div>
                </div>

                {/* Bisemanal */}
                <div className="config-card mora-card red">
                  <h3>Préstamos Bisemanales</h3>
                  <div className="form-group">
                    <label>Porcentaje de Mora (%)</label>
                    <input
                      type="number"
                      value={moraConfig.bisemanal}
                      onChange={(e) => setMoraConfig({...moraConfig, bisemanal: parseFloat(e.target.value) || 0})}
                      min="0"
                      max="100"
                      step="0.1"
                    />
                  </div>
                  <div className="form-group">
                    <label>Días de Gracia</label>
                    <input
                      type="number"
                      value={moraConfig.dias_gracia_bisemanal}
                      onChange={(e) => setMoraConfig({...moraConfig, dias_gracia_bisemanal: parseInt(e.target.value) || 0})}
                      min="0"
                      max="30"
                    />
                  </div>
                </div>

                {/* Diario */}
                <div className="config-card mora-card gray">
                  <h3>Préstamos Diarios</h3>
                  <div className="form-group">
                    <label>Porcentaje de Mora (%)</label>
                    <input
                      type="number"
                      value={moraConfig.diario}
                      onChange={(e) => setMoraConfig({...moraConfig, diario: parseFloat(e.target.value) || 0})}
                      min="0"
                      max="100"
                      step="0.1"
                    />
                  </div>
                  <div className="form-group">
                    <label>Días de Gracia</label>
                    <input
                      type="number"
                      value={moraConfig.dias_gracia_diario}
                      onChange={(e) => setMoraConfig({...moraConfig, dias_gracia_diario: parseInt(e.target.value) || 0})}
                      min="0"
                      max="30"
                    />
                  </div>
                </div>

                {/* Interdiario */}
                <div className="config-card mora-card dark">
                  <h3>Préstamos Interdiarios</h3>
                  <div className="form-group">
                    <label>Porcentaje de Mora (%)</label>
                    <input
                      type="number"
                      value={moraConfig.interdiario}
                      onChange={(e) => setMoraConfig({...moraConfig, interdiario: parseFloat(e.target.value) || 0})}
                      min="0"
                      max="100"
                      step="0.1"
                    />
                  </div>
                  <div className="form-group">
                    <label>Días de Gracia</label>
                    <input
                      type="number"
                      value={moraConfig.dias_gracia_interdiario}
                      onChange={(e) => setMoraConfig({...moraConfig, dias_gracia_interdiario: parseInt(e.target.value) || 0})}
                      min="0"
                      max="30"
                    />
                  </div>
                </div>
              </div>

              <button
                className="btn btn-primary btn-save-all"
                onClick={() => guardarConfiguracion('mora', moraConfig)}
                disabled={saving}
              >
                {saving ? 'Guardando...' : 'Guardar Toda la Configuración'}
              </button>
            </div>
          )}

          {/* Día Interés */}
          {activeTab === 'dia_interes' && (
            <div className="config-section">
              <h2>📅 Cambiar Día de Interés</h2>
              <div className="info-box">
                <p>En esté día de cada mes, luego de la fecha efectiva se generarán los intereses de los préstamos.</p>
                <p><strong>Ejemplo:</strong> en la página pago, en el campo pago, verá un 0 si el día que puso aquí no ha pasado, por lo contrario verá los intereses.</p>
              </div>

              <div className="config-grid-2">
                <div className="config-card">
                  <h3>Día Interés Préstamos Mensuales</h3>
                  <div className="form-group">
                    <label>Día configurado</label>
                    <input
                      type="number"
                      value={diaInteresConfig.mensual}
                      onChange={(e) => setDiaInteresConfig({...diaInteresConfig, mensual: parseInt(e.target.value) || 1})}
                      min="1"
                      max="28"
                    />
                  </div>
                </div>

                <div className="config-card">
                  <h3>Día Interés Préstamos Quincenales</h3>
                  <div className="form-group">
                    <label>Día configurado</label>
                    <input
                      type="number"
                      value={diaInteresConfig.quincenal}
                      onChange={(e) => setDiaInteresConfig({...diaInteresConfig, quincenal: parseInt(e.target.value) || 1})}
                      min="1"
                      max="15"
                    />
                  </div>
                </div>

                <div className="config-card">
                  <h3>Día Interés Préstamos Semanales</h3>
                  <div className="form-group">
                    <label>Día configurado</label>
                    <input
                      type="number"
                      value={diaInteresConfig.semanal}
                      onChange={(e) => setDiaInteresConfig({...diaInteresConfig, semanal: parseInt(e.target.value) || 1})}
                      min="1"
                      max="7"
                    />
                  </div>
                </div>

                <div className="config-card">
                  <h3>Día Interés Préstamos Bisemanales</h3>
                  <div className="form-group">
                    <label>Día configurado</label>
                    <input
                      type="number"
                      value={diaInteresConfig.bisemanal}
                      onChange={(e) => setDiaInteresConfig({...diaInteresConfig, bisemanal: parseInt(e.target.value) || 1})}
                      min="1"
                      max="14"
                    />
                  </div>
                </div>
              </div>

              <button
                className="btn btn-primary"
                onClick={() => guardarConfiguracion('dia-interes', diaInteresConfig)}
                disabled={saving}
              >
                {saving ? 'Guardando...' : 'Actualizar'}
              </button>
            </div>
          )}

          {/* WhatsApp */}
          {activeTab === 'whatsapp' && (
            <div className="config-section">
              <h2>💬 Mi WhatsApp (Prueba)</h2>
              <div className="config-card config-card-small">
                <div className="form-group">
                  <label className="switch-container">
                    <input
                      type="checkbox"
                      checked={whatsappConfig.activo}
                      onChange={(e) => setWhatsappConfig({...whatsappConfig, activo: e.target.checked})}
                    />
                    <span className="switch-slider"></span>
                    <span className="switch-label">Activar integración WhatsApp</span>
                  </label>
                </div>

                {whatsappConfig.activo && (
                  <>
                    <div className="form-group">
                      <label>Número de WhatsApp</label>
                      <input
                        type="text"
                        value={whatsappConfig.numero}
                        onChange={(e) => setWhatsappConfig({...whatsappConfig, numero: e.target.value})}
                        placeholder="1-809-555-5555"
                      />
                    </div>

                    <div className="whatsapp-qr">
                      <div className="qr-placeholder">
                        <p>📱 Código QR</p>
                        <small>Escanea para vincular tu dispositivo</small>
                      </div>
                      <button className="btn btn-primary">🔄 Recargar QR</button>
                    </div>

                    <div className="info-box">
                      <h4>Conéctate a WhatsApp</h4>
                      <ol>
                        <li>Abre la app de WhatsApp en tu teléfono</li>
                        <li>Ve a Configuración {'>'} Dispositivos vinculados</li>
                        <li>Selecciona Vincular un dispositivo</li>
                        <li>Escanea el código QR con la cámara de tu teléfono</li>
                      </ol>
                    </div>
                  </>
                )}

                <button
                  className="btn btn-primary"
                  onClick={() => guardarConfiguracion('whatsapp', whatsappConfig)}
                  disabled={saving}
                >
                  {saving ? 'Guardando...' : 'Actualizar'}
                </button>
              </div>
            </div>
          )}

          {/* Recibos */}
          {activeTab === 'recibo' && (
            <div className="config-section">
              <h2>🧾 Configuración de Recibos</h2>

              <div className="config-grid-2">
                {/* Recibo Amortizado */}
                <div className="config-card">
                  <h3 className="card-title-colored blue">Recibo Amortizado</h3>
                  <p className="card-subtitle">Coteje los recuadros que desea en los recibos</p>

                  <div className="checkbox-group">
                    {Object.keys(reciboConfig.amortizado).map(key => (
                      <label key={key} className="checkbox-label">
                        <input
                          type="checkbox"
                          checked={reciboConfig.amortizado[key]}
                          onChange={(e) => setReciboConfig({
                            ...reciboConfig,
                            amortizado: {...reciboConfig.amortizado, [key]: e.target.checked}
                          })}
                        />
                        <span>{key.replace(/_/g, ' ').replace('mostrar ', '').toUpperCase()}</span>
                      </label>
                    ))}
                  </div>
                </div>

                {/* Recibo Capital Final */}
                <div className="config-card">
                  <h3 className="card-title-colored cyan">Recibo Capital Final</h3>
                  <p className="card-subtitle">Coteje los recuadros que desea en los recibos</p>

                  <div className="checkbox-group">
                    {Object.keys(reciboConfig.capital_final).map(key => (
                      <label key={key} className="checkbox-label">
                        <input
                          type="checkbox"
                          checked={reciboConfig.capital_final[key]}
                          onChange={(e) => setReciboConfig({
                            ...reciboConfig,
                            capital_final: {...reciboConfig.capital_final, [key]: e.target.checked}
                          })}
                        />
                        <span>{key.replace(/_/g, ' ').replace('mostrar ', '').toUpperCase()}</span>
                      </label>
                    ))}
                  </div>
                </div>
              </div>

              {/* Pendientes */}
              <div className="config-card">
                <h3 className="card-title-colored orange">PENDIENTES</h3>
                <div className="checkbox-group checkbox-group-horizontal">
                  {Object.keys(reciboConfig.pendientes).map(key => (
                    <label key={key} className="checkbox-label">
                      <input
                        type="checkbox"
                        checked={reciboConfig.pendientes[key]}
                        onChange={(e) => setReciboConfig({
                          ...reciboConfig,
                          pendientes: {...reciboConfig.pendientes, [key]: e.target.checked}
                        })}
                      />
                      <span>{key.replace(/_/g, ' ').replace('mostrar ', '').toUpperCase()}</span>
                    </label>
                  ))}
                </div>
              </div>

              <button
                className="btn btn-primary"
                onClick={() => guardarConfiguracion('recibo', reciboConfig)}
                disabled={saving}
              >
                {saving ? 'Guardando...' : 'Actualizar'}
              </button>
            </div>
          )}

          {/* Panel y Tasa */}
          {activeTab === 'panel' && (
            <div className="config-section">
              <h2>📊 Panel y Tasa</h2>

              <div className="config-grid-2">
                <div className="config-card">
                  <h3 className="card-title-colored blue">Tablas del panel</h3>
                  <p className="card-subtitle">Seleccione las tablas a mostrar en el panel principal</p>

                  <div className="checkbox-group">
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        checked={panelConfig.mostrar_prestamos_capital_final}
                        onChange={(e) => setPanelConfig({...panelConfig, mostrar_prestamos_capital_final: e.target.checked})}
                      />
                      <span>Préstamos capital final</span>
                    </label>
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        checked={panelConfig.mostrar_prestamos_amortizados}
                        onChange={(e) => setPanelConfig({...panelConfig, mostrar_prestamos_amortizados: e.target.checked})}
                      />
                      <span>Préstamos amortizados</span>
                    </label>
                  </div>
                </div>

                <div className="config-card">
                  <h3 className="card-title-colored green">Frecuencia de la tasa</h3>
                  <p className="card-subtitle">Seleccione cómo se calculará la tasa</p>

                  <div className="radio-group-vertical">
                    <label className="radio-label">
                      <input
                        type="radio"
                        value="mensual"
                        checked={panelConfig.frecuencia_tasa === 'mensual'}
                        onChange={(e) => setPanelConfig({...panelConfig, frecuencia_tasa: e.target.value})}
                      />
                      <span>Frecuencia mensual</span>
                    </label>
                    <label className="radio-label">
                      <input
                        type="radio"
                        value="prestamo"
                        checked={panelConfig.frecuencia_tasa === 'prestamo'}
                        onChange={(e) => setPanelConfig({...panelConfig, frecuencia_tasa: e.target.value})}
                      />
                      <span>Frecuencia del préstamo</span>
                    </label>
                  </div>
                </div>
              </div>

              <button
                className="btn btn-primary"
                onClick={() => guardarConfiguracion('panel', panelConfig)}
                disabled={saving}
              >
                {saving ? 'Guardando...' : 'Actualizar'}
              </button>
            </div>
          )}

          {/* Modalidades */}
          {activeTab === 'modalidades' && (
            <div className="config-section">
              <h2>💰 Modalidades de Préstamos</h2>
              <p className="section-subtitle">Activar/Desactivar modalidades de préstamos disponibles</p>

              <div className="config-card">
                <h3 className="card-title-colored blue">Activar/Desactivar</h3>

                <div className="toggle-grid">
                  {Object.keys(modalidadesConfig).map(modalidad => (
                    <div key={modalidad} className="toggle-item">
                      <label className="switch-container">
                        <input
                          type="checkbox"
                          checked={modalidadesConfig[modalidad]}
                          onChange={(e) => setModalidadesConfig({...modalidadesConfig, [modalidad]: e.target.checked})}
                        />
                        <span className="switch-slider"></span>
                        <span className="switch-label capitalize">{modalidad}</span>
                      </label>
                    </div>
                  ))}
                </div>
              </div>

              <button
                className="btn btn-primary"
                onClick={() => guardarConfiguracion('modalidades', modalidadesConfig)}
                disabled={saving}
              >
                {saving ? 'Guardando...' : 'Actualizar'}
              </button>
            </div>
          )}

          {/* Finanzas */}
          {activeTab === 'finanzas' && (
            <div className="config-section">
              <h2>💼 Módulo de Finanzas</h2>

              <div className="config-card">
                <div className="form-group">
                  <label className="switch-container switch-large">
                    <input
                      type="checkbox"
                      checked={finanzasConfig.activo}
                      onChange={(e) => setFinanzasConfig({...finanzasConfig, activo: e.target.checked})}
                    />
                    <span className="switch-slider"></span>
                    <span className="switch-label">
                      <strong>Activar/Desactivar</strong>
                      <small>Módulo de Finanzas completo</small>
                    </span>
                  </label>
                </div>

                {finanzasConfig.activo && (
                  <>
                    <h3 className="subsection-title">Elementos del módulo</h3>
                    <ul className="finanzas-list">
                      {Object.keys(finanzasConfig).filter(k => k !== 'activo').map(elemento => (
                        <li key={elemento}>
                          <label className="checkbox-label">
                            <input
                              type="checkbox"
                              checked={finanzasConfig[elemento]}
                              onChange={(e) => setFinanzasConfig({...finanzasConfig, [elemento]: e.target.checked})}
                            />
                            <span className="capitalize">{elemento.replace(/_/g, ' ')}</span>
                          </label>
                        </li>
                      ))}
                    </ul>
                  </>
                )}
              </div>

              <button
                className="btn btn-primary"
                onClick={() => guardarConfiguracion('finanzas', finanzasConfig)}
                disabled={saving}
              >
                {saving ? 'Guardando...' : 'Actualizar'}
              </button>
            </div>
          )}

          {/* Préstamos */}
          {activeTab === 'prestamos' && (
            <div className="config-section">
              <h2>📋 Configuración de Préstamos</h2>

              <div className="config-grid-2">
                <div className="config-card">
                  <h3 className="card-title-colored green">Deben pagar hoy</h3>
                  <div className="radio-group-vertical">
                    <label className="radio-label">
                      <input
                        type="radio"
                        checked={prestamosConfig.deben_pagar_con_adelantados}
                        onChange={() => setPrestamosConfig({...prestamosConfig, deben_pagar_con_adelantados: true})}
                      />
                      <span>Los préstamos deben aparecer aunque tengan pagos adelantados</span>
                    </label>
                    <label className="radio-label">
                      <input
                        type="radio"
                        checked={!prestamosConfig.deben_pagar_con_adelantados}
                        onChange={() => setPrestamosConfig({...prestamosConfig, deben_pagar_con_adelantados: false})}
                      />
                      <span>Los préstamos no aparecerán si tienen pagos adelantados</span>
                    </label>
                  </div>
                </div>

                <div className="config-card">
                  <h3 className="card-title-colored cyan">Mora préstamo vencido</h3>
                  <div className="radio-group-vertical">
                    <label className="radio-label">
                      <input
                        type="radio"
                        checked={prestamosConfig.aumentar_mora_vencido}
                        onChange={() => setPrestamosConfig({...prestamosConfig, aumentar_mora_vencido: true})}
                      />
                      <span>Aumentar mora cuando el préstamo esté vencido</span>
                    </label>
                    <label className="radio-label">
                      <input
                        type="radio"
                        checked={!prestamosConfig.aumentar_mora_vencido}
                        onChange={() => setPrestamosConfig({...prestamosConfig, aumentar_mora_vencido: false})}
                      />
                      <span>Dejar mora intacta cuando el préstamo esté vencido</span>
                    </label>
                  </div>
                </div>
              </div>

              <button
                className="btn btn-primary"
                onClick={() => guardarConfiguracion('prestamos', prestamosConfig)}
                disabled={saving}
              >
                {saving ? 'Guardando...' : 'Actualizar'}
              </button>
            </div>
          )}

          {/* Abogado */}
          {activeTab === 'abogado' && (
            <div className="config-section">
              <h2>⚖️ Abogado Notario</h2>

              <div className="config-card config-card-small">
                <div className="form-group">
                  <label>Nombre</label>
                  <input
                    type="text"
                    value={abogadoConfig.nombre}
                    onChange={(e) => setAbogadoConfig({...abogadoConfig, nombre: e.target.value})}
                    placeholder="Nombre del abogado"
                  />
                </div>

                <div className="form-group">
                  <label>Cédula</label>
                  <input
                    type="text"
                    value={abogadoConfig.cedula}
                    onChange={(e) => setAbogadoConfig({...abogadoConfig, cedula: e.target.value})}
                    placeholder="000-0000000-0"
                  />
                </div>

                <div className="form-group">
                  <label>Dirección</label>
                  <input
                    type="text"
                    value={abogadoConfig.direccion}
                    onChange={(e) => setAbogadoConfig({...abogadoConfig, direccion: e.target.value})}
                    placeholder="Calle, #Casa, Sector, Municipio, Provincia"
                  />
                </div>

                <div className="form-group">
                  <label>Matrícula</label>
                  <input
                    type="text"
                    value={abogadoConfig.matricula}
                    onChange={(e) => setAbogadoConfig({...abogadoConfig, matricula: e.target.value})}
                    placeholder="Número de matrícula"
                  />
                </div>

                <button
                  className="btn btn-primary"
                  onClick={() => guardarConfiguracion('abogado', abogadoConfig)}
                  disabled={saving}
                >
                  {saving ? 'Guardando...' : 'Actualizar'}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Configuracion;
